import { useEffect, useMemo, useState } from "react";
import { api } from "../lib/api.js";
import { useT } from "../lib/i18n.jsx";
import { IconSearch } from "../components/icons.jsx";

const TONE = { "setup.": "acc", "admin.": "acc", "auth.login": "ok", "auth.fail": "err" };
function tone(a) { for (const [k, v] of Object.entries(TONE)) if (a?.startsWith(k)) return v; return ""; }

export default function AdminAuditPage() {
  const { t } = useT();
  const [entries, setEntries] = useState(null);
  const [filter, setFilter] = useState("");

  async function load() { const r = await api("/admin/audit?limit=200"); setEntries(r.entries); }
  useEffect(() => { load(); const id = setInterval(load, 15000); return () => clearInterval(id); }, []);

  const filtered = useMemo(() => {
    if (!entries) return null;
    const f = filter.trim().toLowerCase();
    if (!f) return entries;
    return entries.filter((e) =>
      e.action?.toLowerCase().includes(f) || e.user_email?.toLowerCase().includes(f) ||
      e.ip_address?.toLowerCase().includes(f) || e.device_name?.toLowerCase().includes(f)
    );
  }, [entries, filter]);

  if (!entries) return <div className="loading">{t("common_loading")}</div>;

  return (
    <>
      <div className="ph">
        <div className="ph-title">
          <div className="eyebrow">Administration</div>
          <h1 className="h1">{t("admin_audit_title")}</h1>
        </div>
        <div className="ph-meta">{entries.length} most recent · 15s refresh</div>
      </div>
      <div className="toolbar">
        <div className="search">
          <IconSearch className="search-icon" size={14} />
          <input type="text" placeholder={t("admin_audit_search")} value={filter} onChange={(e) => setFilter(e.target.value)} />
        </div>
      </div>
      <div className="section">
        <div className="section-body" style={{ padding: 0 }}>
          {filtered.length === 0 ? (
            <div style={{ padding: 60, textAlign: "center" }}>
              <span className="serif italic-serif" style={{ fontSize: 18, color: "var(--text-mute)" }}>{t("admin_audit_no_entries")}</span>
            </div>
          ) : (
            <table className="tbl">
              <thead><tr><th>When</th><th>Action</th><th>User</th><th>Device</th><th>IP</th><th>Details</th></tr></thead>
              <tbody>
                {filtered.map((e) => (
                  <tr key={e.id}>
                    <td className="mono" style={{ fontSize: 11, color: "var(--text-dim)" }}>
                      {new Date(e.created_at).toISOString().slice(0, 19).replace("T", " ")}
                    </td>
                    <td><span className={"chip " + tone(e.action || "")}>{e.action}</span></td>
                    <td>{e.user_email ? <span className="mono" style={{ fontSize: 11 }}>{e.user_email}</span> : <span className="dim">—</span>}</td>
                    <td>{e.device_name || <span className="dim">—</span>}</td>
                    <td className="mono" style={{ fontSize: 11, color: "var(--text-dim)" }}>{e.ip_address || "—"}</td>
                    <td className="mono" style={{ fontSize: 10.5, color: "var(--text-faint)", maxWidth: 320, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {e.details ? (typeof e.details === "string" ? e.details : JSON.stringify(e.details)) : ""}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </>
  );
}
